/**
 * Created by BFR on 21/08/2020.
 */
define('productCompetitorView',[
    'module',
    'marionette',
    'app',
    'jquery',
    'underscore',
    'template!productCompetitorTpl',
    'competitorCreateEditLayoutView'
  ], function(
    module,
    Marionette,
    App,
    $,
    _,
    viewTpl,
    CompetitorCreateEditLayoutView
  ) {
    'use strict';

    module.exports = Marionette.LayoutView.extend({
      template: viewTpl,
      className: 'col-xs-12',

      modelEvents: {
        'change': 'render'
      },
  
      regions: {
      },

      ui: {
      },

      events: {
        'click .btn-remove-competitor': 'onBtnRemoveCompetitorClick',
        'click .btn-comment': 'onEditClick',
        'click .btn-edit': 'onEditClick'
      },

      serializeData: function () {
        var templateData = this.options.model.toJSON();
        return templateData;
      },

      onEditClick: function() {
        var competitorCreateEditLayoutView = new CompetitorCreateEditLayoutView({
          model: this.model
        });

        competitorCreateEditLayoutView.show({
          title: _.i18n('competitors.title')
        });
      },

      onBtnRemoveCompetitorClick: function() {
        this.model.destroy();
      }
    });
  });
